import {
  Button,
  DateInput,
  TextInput,
  required,
  useDataProvider,
  useListContext,
  useNotify,
  useRefresh,
  useUnselectAll,
} from "react-admin";
import DoneIcon from "@mui/icons-material/Done";
import ThumbDownIcon from "@mui/icons-material/ThumbDownOffAlt";
import FormModal from "server/components/Modals/FormModal";
import { ACADEMIC_DECISIONS, DecisionTypes, StudentServicePath } from "utils/constants";

const InterruptButton = () => {
  const { selectedIds, resource } = useListContext();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll(resource);

  // No try/catch: FormModal notifies on error and stays open.
  const interruptStudies = async data => {
    await dataProvider.create(`${StudentServicePath}${ACADEMIC_DECISIONS}`, {
      data: { decisionType: DecisionTypes.Interruption, educationDecisionIds: selectedIds, ...data },
    });
    notify("Успешно прекъснато обучение на избраните студенти", { type: "success" });
    refresh();
    unselectAll();
  };

  return (
    <FormModal
      triggerButton={
        <Button label="Прекъсни обучение">
          <ThumbDownIcon />
        </Button>
      }
      titleContent="Прекъсване на обучение"
      onConfirm={interruptStudies}
      saveTitle="Прекъсни"
      saveIcon={<DoneIcon />}
      closeTitle="Затвори"
      dialogSize="xs"
    >
      <DateInput
        source="orderDate"
        label="Дата на заповед"
        validate={required()}
        helperText={false}
        fullWidth
      />
      <TextInput
        source="orderNumber"
        label="Номер на заповед"
        validate={required()}
        helperText={false}
        fullWidth
      />
      <TextInput
        source="note"
        label="Бележка"
        multiline
        fullWidth
      />
    </FormModal>
  );
};

export default InterruptButton;
